<template>
  <div ref="MyInterestsAbstract" class="my-interests-abstract transparent">
    <jumbotron
      :title="$t('myInterests.abstract.title')"
      :paragraph="$t('myInterests.abstract.description')"
      :position="screenIsLargeOrLarger ? 'right' : 'left'"
      backgroundImage="/img/jumbotron/big-forest-tree.jpg"
      color="primary"
      direction="bottom"
    />
    <h2 class="my-interests-abstract-title text-center">
      {{ $t("myInterests.abstract.subtitle") }}
    </h2>
    <p
      v-for="(text, i) in $t('myInterests.abstract.textes')"
      :key="`my-interests-abstract-text${i}`"
      class="my-interests-abstract-text text-justify"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
const Jumbotron = () =>
  import(/* webpackChunkName: "JumbotronComponent" */ "@/components/Global/Jumbotron.vue");

export default {
  name: "MyInterestsAbstract",
  components: {
    Jumbotron
  },
  computed: {
    /*
     * @computed - screenIsLargeOrLarger
     * TRUE if screen is large or larger width
     */
    screenIsLargeOrLarger() {
      return this.$store.state.Global.window.width >= this.$utils.styles.breakpoints.large;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-interests-abstract {
  &-title {
    margin-top: 3rem;
  }

  &-text {
    @include breakpoint($small) {
      font-size: 1.25rem;
    }
  }
}
</style>
